import React, { useContext } from "react";
import { useCookies } from "react-cookie";
import { AiOutlineMenu } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { MenuContext } from "../context/MenuContext";

const BellIcon = ({ className = "" }) => (
  <svg
    viewBox="0 0 24 24"
    className={className}
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M12 22a2.2 2.2 0 0 0 2.2-2.2H9.8A2.2 2.2 0 0 0 12 22Z"
      fill="currentColor"
      opacity="0.9"
    />
    <path
      d="M18 10a6 6 0 1 0-12 0c0 6-2 6.5-2 6.5h16S18 16 18 10Z"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinejoin="round"
    />
    <path
      d="M12 4V2.5"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
    />
  </svg>
);

export function TopBar() {
  const [cookies] = useCookies();
  const navigate = useNavigate();
  const { menuOpen, setMenuOpen } = useContext(MenuContext)

  return (
    <div className="w-full">
      {/* Top bar container */}
      <div className="relative overflow-hidden border-b border-[#C59F59]/10 px-5 py-2 sm:px-7 sm:py-4">
        <div className="relative flex flex-row gap-4 justify-between">
          {/* Left */}
          <div className="min-w-0">
            <h1 className="truncate text-xl text-white/90 sm:text-3xl">
              Welcome back, {cookies?.userProfile?.first_name}
            </h1>

            <div className="mt-2 flex items-center gap-2 text-sm">
              <span className="text-white/50">Member ID:</span>
              <span className="font-semibold tracking-widest text-[#d8b05a]">
                {cookies?.userProfile?.member_id}
              </span>
            </div>
          </div>

          {/* Right */}
          <div className="flex items-center gap-3 sm:gap-4">
            {/* <button
              type="button"
              className={[
                "grid h-11 w-11 place-items-center rounded-full",
                "border border-white/10 bg-white/5 text-white/50",
                "hover:text-white/85 hover:bg-white/10",
                "focus:outline-none focus:ring-4 focus:ring-[#d8b05a]/15",
                "transition",
              ].join(" ")}
              aria-label="Notifications"
            >
              <BellIcon className="h-5 w-5" />
            </button> */}

            <button
              type="button"
              onClick={() => navigate('/dashboard/charter-jet')}
              className={[
                "h-11 flex items-center rounded-full px-6 text-sm font-semibold",
                "shadow-[0_3px_8px_rgba(216,176,90,0.25)]",
                "bg-[#d8b05a] text-black",
                "hover:brightness-110 active:brightness-95",
                "focus:outline-none focus:ring-4 focus:ring-[#d8b05a]/20",
                "transition hidden sm:flex",
              ].join(" ")}
            >
              Charter a Jet
            </button>
            <div
                onClick={() => {setMenuOpen(true); console.log(menuOpen)}}
                className="flex cursor-pointer items-center justify-center lg:hidden"
            >
                <AiOutlineMenu color="#ffffff" size={20} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}